/**
 * Helper function to format error messages for display
 * Extracts just the message content from API error responses
 */
export const formatErrorMessage = (error: unknown): string => {
  if (error instanceof Error) {
    let message = error.message;

    // Try to extract message from JSON response
    // Example: "API Error: 409 Conflict - {"success":false,"message":"Country with code \"CA\" already exists"}"
    const jsonMatch = message.match(/\{.*\}/);
    if (jsonMatch) {
      try {
        const parsedError = JSON.parse(jsonMatch[0]);
        if (parsedError.message) {
          message = parsedError.message;
        }
      } catch {
        // If JSON parsing fails, continue with original message
      }
    }

    // Clean up escaped characters and formatting issues
    return message
      .replace(/\\"/g, '"') // Replace \" with "
      .replace(/\\'/g, "'") // Replace \' with '
      .replace(/\\n/g, ' ') // Replace \n with space
      .replace(/\s+/g, ' ') // Replace multiple spaces with single space
      .trim();
  }
  return 'Unknown error occurred';
};
